export const PRODUCT_TRACKING_EVENTS = {
  JOURNEYS: 'Journeys Page Visited',
  WORKFLOWS: 'Workflows Page Visited',
  VOICEFLOW: 'Voiceflow Page Visited',
  DATABASE_CLEANUP: 'Database Cleanup Page Visited',
  PEOPLE_CANDIDATES: 'People Candidates Page Visited',
  PEOPLE_LISTS: 'People Lists Page Visited',
  PEOPLE_LEADS: 'People Leads Page Visited',
  PEOPLE_CONTACTS: 'People Contacts Page Visited',
  CHATBOT: 'Chatbot Page Visited',
  SCHEDULING: 'Scheduling Page Visited',
  DASHBOARD: 'Dashboard Page Visited',
  REFERRALS: 'Referrals Page Visited',
  PAGES: 'Pages Page Visited',
  CAREER_SITES: 'Career Sites Page Visited',
  MESSAGING: 'Messaging Page Visited',
  MESSAGING_BROADCAST: 'Messaging Broadcast Page Visited',
  MESSAGING_CONTACTS: 'Messaging Contacts Page Visited',
} as const;
